import logo from '../../assets/images/logo.png';

const Images = {
  logo,
};

export default Images;
